import React, { useContext, useEffect, useState } from "react";
import { MainWebsiteEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import { GcSessionInfo } from "@glamcorner/gc-types/generated/types";
import { Bus } from "../../services/Bus";

export interface SessionContextValue {
  gcSession: GcSessionInfo | null;
}

export const SessionContext = React.createContext<SessionContextValue>({
  gcSession: null,
});

export const SessionProvider: React.FC = ({ children }) => {
  const [gcSession, setGcSession] = useState<GcSessionInfo | null>(null);

  useEffect(() => {
    let isMountedToComponent = true;

    Bus.on(MainWebsiteEvents.GcSessionXhrFinished, {}, async (gcSessionPayload: GcSessionInfo) => {
      // If the SessionProvider has been unmounted then skip setting the new session state.
      // This is unlikely to occur outside of tests but is good practice since React will
      // output a warning if we try to update the state of an unmounted component.
      if (isMountedToComponent) {
        setGcSession(gcSessionPayload);
      }
    });

    return () => {
      isMountedToComponent = false;
    };
  }, []);

  const contextValue: SessionContextValue = {
    gcSession,
  };

  return <SessionContext.Provider value={contextValue}>{children}</SessionContext.Provider>;
};

export const useSession = () => useContext(SessionContext);
